import { render } from "./App.vue?vue&type=template&id=700a6e9a&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=700a6e9a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-700a6e9a"

export default script